<template>
  <div class="form-group">
    <label for="ipt_cod" class="control-label col-sm-12">
      Endereço {{title}}
      <a :href="googleLink()" target="_blank" class="glyphicon glyphicon-globe" title="Google Maps"></a>
    </label>
      
    <div class="form-group col-sm-7">
      <input type="text" v-model="ender.rua" @focusout="add('rua',ender.rua)" maxlength="50" class="form-control up" placeholder="Logradouro"/>
    </div>
        
    <div class="form-group col-sm-2">
      <input type="text" v-model="ender.numero" @focusout="add('numero',ender.numero)" class="form-control up" placeholder="Número"/>
    </div>
        
    <div class="form-group col-sm-2">
      <input type="text" v-model="ender.compl" @focusout="add('compl',ender.compl)" maxlength="10" class="form-control up" placeholder="Complemento" />
    </div>
        
    <div class="form-group col-sm-2">
      <input type="text" v-model="ender.cep" @focusout="maskCepInput($event);add('cep',ender.cep)" @keydown="maskCepInput($event)" @keyup="maskCepInput($event)" class="form-control" placeholder="Cep"/>
    </div>
        
    <div class="form-group col-sm-4">
      <input type="text" v-model="ender.bairro" @focusout="add('bairro',ender.bairro)" maxlength="20" class="form-control up" placeholder="Bairro" />
    </div>
        
    <div class="form-group col-sm-4">
      <input type="text" v-model="ender.cidade" @focusout="add('cidade',ender.cidade)" maxlength="20" class="form-control up" placeholder="Cidade" />
    </div>

    <div class="form-group col-sm-1">
      <input type="text" v-model="ender.uf" @focusout="add('uf',ender.uf)" maxlength="2" class="form-control up" placeholder="UF" />
    </div>

    <div class="form-group col-sm-11">
      <input type="text" v-model="ender.referencia" placeholder="Referências, detalhes" class="form-control">
    </div>
	</div>
</template>

<script>
  import Mask from './Mask.js'
  export default {
    name: 'endereco',
    props: ['prefix', 'ender', 'title'],
    data () {
      return {
        no: ''
      }
    },
    methods: {
      add (key, value) {
        this.$emit('insert', this.prefix, key, value)
      },
      maskCepInput (e) {
        e.target.value = Mask.cep(e.target.value)
      },
      googleLink () {
        const google = 'https://www.google.com.br/maps/place/'
        const endereco = this.ender.rua + ',' + this.ender.numero + '-' + this.ender.bairro + ',' + this.ender.cidade + '-' + this.ender.uf
        return google + endereco
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/CliFormEndereco.vue